export default __webpack_public_path__ + "static/media/close.5ed230ee.svg";